import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import { getCurrentUserRequest } from 'store/Auth/Auth.action';
import { IRootStore } from 'store/Root.reducer';

import { PAGES } from 'utils/link';

interface PrivateRouteProps {
  children: React.ReactElement;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const dispatch = useDispatch();
  const { isAuthenticated, loading, user } = useSelector((state: IRootStore) => state.auth);
  const location = useLocation();
  const token = localStorage.getItem('access_token');

  useEffect(() => {
    if (token && !user && !loading) {
      dispatch(getCurrentUserRequest());
    }
  }, [token, user, loading, dispatch]);

  if (loading || (token && !user)) {
    return <div>Загрузка...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to={PAGES.AUTH_LOGIN} state={{ from: location }} replace />;
  }

  const isWelcomePage = location.pathname === PAGES.WELCOME;
  const hasSensors = user?.role === 'admin' || (user?.meta?.sensors_count ?? 0) > 0;

  if (!hasSensors && !isWelcomePage) {
    return <Navigate to={PAGES.WELCOME} replace />;
  }

  return children;
};
